import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import listenerMiddleware from './middlewares';
import app from './slices/app';
import catalog from './slices/catalog';
import category from './slices/category';
import draftstatus from './slices/draftstatus';
import error from './slices/error';
import importitems from './slices/importitems';
import indicator from './slices/indicator';
import intl from './slices/intl';
import invalidCategoryImages from './slices/invalidCategoryImages/invalidCategoryImages';
import item from './slices/item';
import market from './slices/market';
import modal from './slices/modal';
import ongoingrequests from './slices/ongoingrequests';
import pane from './slices/pane';
import pond from './slices/pond';
import prestate from './slices/prestate';
import notvalidforstructureitems from './slices/reports/notvalidforstructureitems';
import roles from './slices/roles';
import statistics from './slices/statistics/statistics';
import toaster from './slices/toaster';
import tree from './slices/tree';
import treeSelection from './slices/treeSelection';
import treeSearch from './slices/treeSearch';
import treeDrag from './slices/treeDrag';
import treeSort from './slices/treeSort';
import { navigation } from './middlewares/navigation';

export const rootReducer = combineReducers({
  app,
  catalog,
  category,
  draftstatus,
  error,
  importitems,
  indicator,
  intl,
  invalidCategoryImages,
  item,
  market,
  modal,
  ongoingrequests,
  pane,
  pond,
  prestate,
  notvalidforstructureitems,
  roles,
  statistics,
  toaster,
  tree,
  treeSelection,
  treeSearch,
  treeDrag,
  treeSort,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
      .prepend(listenerMiddleware.middleware)
      .concat(navigation),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export type AppThunkDispatch = ThunkDispatch<RootState, unknown, UnknownAction>;
